module.exports = __webpack_public_path__ + "img/line-blue-long-swoop.3f5594ea.png";